module.exports = __webpack_public_path__ + "static/media/anibal_moreno.2dcfdc47.jpg";